import { render } from "./ClaimPage.vue?vue&type=template&id=795104fa"
import script from "./ClaimPage.vue?vue&type=script&lang=js"
export * from "./ClaimPage.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__